import { render, staticRenderFns } from "./StatusInvoice.vue?vue&type=template&id=8f083972"
import script from "./StatusInvoice.vue?vue&type=script&lang=js"
export * from "./StatusInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports